import { DownloadSecurityContainerGzDataProvider } from '../dataProvider/DownloadSecurityContainerGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class DownloadSecurityContainerDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, DownloadSecurityContainerGzDataProvider);
  }
}
